module.exports = __webpack_public_path__ + "img/united-foundation.a20735c0.jpeg";